/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Nobox {

    import fld = LeadRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.filterable()
    export class LeadGrid extends NoboxEntityGrid<LeadRow, any> {
        protected getColumnsKey() { return LeadColumns.columnsKey; }
        protected getDialogType() { return LeadDialog; }
        protected getIdProperty() { return LeadRow.idProperty; }
        protected getInsertPermission() { return LeadRow.insertPermission; }
        protected getLocalTextPrefix() { return LeadRow.localTextPrefix; }
        protected getService() { return LeadService.baseUrl; }


        constructor(container: JQuery) {
            super(container);
            Q.serviceCall({
                blockUI: true,
                url: "/Services/" + CustomFields.CustomfieldsService.baseUrl + "/Retrieve",
                request: {
                    EntityId: 1,
                },
                onSuccess: (res: Serenity.RetrieveResponse<CustomFields.CustomfieldsRow>) => {
                    $("#customFldContactData").val(JSON.stringify(res.Entity));
                }
            })
            var q = Q.parseQueryString();
            if (q["country"]) {
                var categoryCt = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    LeadRow.Fields.Country)
                categoryCt.value = q["country"];
            }
            if (q["tool"]) {
                var categoryTl = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    LeadRow.Fields.Tool)
                categoryTl.value = q["tool"];
            }
            if (q["sd"] && q["ed"]) {
                var categoryDt = this.findQuickFilter(CustomDateFilter,
                    LeadRow.Fields.In);
                if (q["sd"] == "All" || q["ed"] == "All") {
                    categoryDt.set_value(null);
                    categoryDt.end_set_value(null);
                } else {
                    categoryDt.set_value(q["sd"]);
                    categoryDt.end_set_value(q["ed"]);
                }
            }
        }

        protected getQuickFilters() {
            var flt = super.getQuickFilters();
            //this.refresh();
            var filter1 = Q.first(flt, x => x.field == fld.ListId);
            filter1.handler = h => {
                const request = (h.request as LeadListRequest);
                const values = (h.widget as Serenity.ServiceLookupEditor).values;
                if (h.active) {
                    request.ListIds = values.map(x => Number(x));
                    h.handled = true;
                } else {
                    request.ListIds = [];
                    h.handled = true;
                }
            };
            var filter2 = Q.first(flt, x => x.field == LeadRow.Fields.Tags);
            filter2.handler = h => {
                const request = (h.request as LeadListRequest);
                const values = (h.widget as Serenity.ServiceLookupEditor).values;
                if (h.active) {
                    request.Tags = values.map(x => x);
                    h.handled = true;
                } else {
                    request.Tags = [];
                    h.handled = true;
                }
            };
            var filter3 = Q.first(flt, x => x.field == LeadRow.Fields.Category);
            filter3.handler = h => {
                const request = (h.request as LeadListRequest);
                const value = (h.widget as Serenity.StringEditor).value;
                if (h.active) {
                    request.Category = value;
                } else {
                    request.Category = null;
                }
            };

            var filter4 = Q.first(flt, x => x.field == LeadRow.Fields.In);
            filter4.handler = h => {
                const request = (h.request as LeadListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (h.active) {
                    if (start != null && end != null) {
                        request.Criteria = [[["In"], ">=", start], "and", [["In"], "<=", end]]
                    } else if (start != null) {
                        request.Criteria = [["In"], ">=", start];
                    } else if (end != null) {
                        request.Criteria = [["In"], "<=", end];
                    }
                    h.handled = true;
                } else {
                    h.handled = true;
                }
            };
            return flt;
        }
        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            let lists = Q.getLookup("Nobox.ListLookup").itemById as unknown as ListRow[];

            Q.first(columns, x => x.field == fld.Category).format =
                ctx => `<a href="javascript:;" class="category-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == fld.Tool).format =
                ctx => `<a href="javascript:;" class="tool-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == fld.Country).format =
                ctx => `<a href="javascript:;" class="ctry-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == fld.State).format =
                ctx => `<a href="javascript:;" class="stt-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == fld.City).format =
                ctx => `<a href="javascript:;" class="cty-link">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == fld.ListId).format =
                ctx => {
                    let idList = ctx.value;
                    if (!idList)
                        return "";

                    idList = idList.split(",") as number[]
                    var elList = "";
                    var idLast = 0;
                    idList.forEach(function (x) {
                        let g = lists[BigInt(x)] as any;
                        idLast = x;
                        if (!g) {
                            elList += `<span id="${x.toString()}" class="list-link">${x.toString()}, </span>`;
                        } else {
                            elList += `<span id="${x.toString()}" class="list-link">${Q.htmlEncode(g.Nm)}, </span>`;
                        }
                    });
                    if (lists[BigInt(idLast)]) {
                        return `<a href="javascript:;">${elList.replace(lists[BigInt(idLast)].Nm + ", ", lists[BigInt(idLast)].Nm)}</a>`;
                    } else {
                        return `<a href="javascript:;">${elList.replace(idLast.toString() + ", ", idLast.toString())} </a>`;
                    }
                };

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("category-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by category");
                var categoryFilter = this.findQuickFilter(Serenity.StringEditor,
                    LeadRow.Fields.Category);
                categoryFilter.value = item.Category;
                this.refresh();
            } else if (target.hasClass("tool-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by Tool");
                var typesignFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    LeadRow.Fields.Tool);
                typesignFilter.value = item.Tool,
                    this.refresh();
            } else if (target.hasClass("tags-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by tags");
                var tagsFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    LeadRow.Fields.Tags);
                tagsFilter.set_value(tagsFilter.get_value() + "," + target.text());
                this.refresh();
            } else if (target.hasClass("list-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by list");
                var listFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    LeadRow.Fields.ListId);
                listFilter.set_value(listFilter.get_value() + "," + target.attr("id"));
                this.refresh();
            } else if (target.hasClass("ctry-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by country");
                var countryFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    LeadRow.Fields.Country);
                countryFilter.set_value(item.Country);
                this.refresh();
            } else if (target.hasClass("stt-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by state");
                var stateFilter = this.findQuickFilter(StateNmLookupEditor,
                    LeadRow.Fields.State);
                stateFilter.set_value(item.State);
                this.refresh();
            } else if (target.hasClass("cty-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by city");
                var cityFilter = this.findQuickFilter(CityNmLookupEditor,
                    LeadRow.Fields.City);
                cityFilter.set_value(item.City);
                this.refresh();
            }
        }

        protected getButtons() {
            var $this = this;
            var buttons = super.getButtons();
            var titleExcel = $(document).width() < 576 ? "" : "Import Excel & CSV";
            buttons.push({
                separator: true,
                title: titleExcel,
                hint: "Import Excel & CSV",
                icon: "fa-download text-green",
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new ExcelImportDialog();
                    dialog.grid = $this;
                    dialog.element.on('dialogclose', () => {
                        $this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });

            var titleGContact = $(document).width() < 576 ? "" : "Google Contacts";
            buttons.push({
                separator: true,
                title: titleGContact,
                hint: "Export to Google Contacts file import",
                icon: "fa-upload text-green",
                onClick: () => {
                    // open import dialog, let it handle rest
                    var link = document.createElement('a');
                    link.href = Q.resolveUrl(`~/Services/Nobox/Contact/GoogleContacts`);
                    link.click()
                }
            });

            var titleFb = $(document).width() < 576 ? "" : "Fb Audiences";
            buttons.push({
                separator: true,
                title: titleFb,
                hint: "Export to Facebook Audiences",
                icon: "fa-upload text-green",
                onClick: () => {
                    // open import dialog, let it handle rest
                    var link = document.createElement('a');
                    link.href = Q.resolveUrl(`~/Services/Nobox/Contact/FbAudiences`);
                    link.click()
                }
            });
            return buttons;
        }



        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            request.ColumnSelection = 1;
            return true;
        }
    }
}